export default __webpack_public_path__ + "static/media/ironridgelogo.df36b1f4.png";